const STATE = {
  allTags: null,
  addEditTagModal: {
    isOpen: false,
    data: null,
    isEditMode: false,
  },
};

export default STATE;
